import * as React from 'react';
import { cn } from './lib/utils';

/**
 * Container for a row of filter controls.
 * Wraps on mobile, consistent 8px gap, bottom margin.
 *
 * <FilterBar>
 *   <FilterSearch ... />
 *   <FilterSelect ... />
 *   <FilterToggle ... />
 *   <FilterClear ... />
 * </FilterBar>
 *
 * align="start"  — children left-aligned (default)
 * align="end"    — children pushed right (useful when FilterClear lives here)
 * align="between"— space-between (search left, clear right)
 */

const ALIGN = {
  start:   'justify-start',
  end:     'justify-end',
  between: 'justify-between',
};

function FilterBar({ children, align = 'start', className, ...props }) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2',
        ALIGN[align] ?? ALIGN.start,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export { FilterBar };
